module.exports = __webpack_public_path__ + "img/loadingImg.c4133435.svg";